<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-26 16:59:56
-->
<template>
  <div class="contain">
    <section>
      <div class="top-header">
        <!-- <div class="header">企业诉求</div> -->
        <div>
          共<b>{{ total }}</b
          >条诉求
        </div>
      </div>
      <div class="demandBox">
        <div class="serviceBox">
          <el-table
            :data="tableData"
            :height="4.3 + 'rem'"
            style="width: 100%"
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <!-- <el-table-column type="index" label="序号"> </el-table-column> -->
            <template slot="empty">
              <img src="@/assets/images/暂无数据.png" alt="" />
              <div style="color: #00fffe;font-size: 0.14rem;">
                暂无数据
              </div>
            </template>
            <el-table-column prop="title" label="诉求标题"> </el-table-column>
            <el-table-column prop="categoryName" label="分类">
            </el-table-column>
            <el-table-column prop="submitTime" label="提交时间">
            </el-table-column>
            <el-table-column
              prop="replyTime"
              label="回复时间"
            ></el-table-column>
            <el-table-column prop="status" label="诉求状态">
              <template slot-scope="scope">
                {{ scope.row.status | statusFilter }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="personnel">
          <div class="personnel-title">
            <i></i>
            入驻专员
          </div>
          <div v-if="userList.length > 0">
            <div
              class="personnel-list"
              v-for="(item, index) in userList"
              :key="index"
            >
              <img src="../../../../assets/images/appeal-list.png" alt="" />
              <div class="personnel-list-rights">
                <div class="name">{{ item.contact }}</div>
                <div class="address">
                  <span>职位：</span> {{ item.position }}
                </div>
                <div class="address">
                  <span>所属区县：</span>{{ item.town }}
                </div>
              </div>
            </div>
          </div>

          <div class="personnel-empty" v-else>
            <img src=".././../../../assets/images/appealk.png" alt="" />
            暂无入驻专员
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import { entAppealList } from '@api/cockpit/index'
export default {
  props: {
    creditCode: {
      type: String,
      default: ''
    }
  },
  computed: {},
  components: {},
  data() {
    return {
      tableData: [],
      userList: [],
      total: 0
    }
  },
  filters: {
    statusFilter(val) {
      switch (Number(val)) {
        case 0:
          return '待回复'
        case 1:
          return '已回复'
        case 2:
          return '已评价'
        case 3:
          return '已撤回'
        case 4:
          return '已流转'
        case 5:
          return '已提交'
      }
    }
  },
  watch: {},
  created() {
    this.getCountAndList()
  },
  mounted() {},
  methods: {
    getCountAndList() {
      entAppealList({ creditCode: this.creditCode }).then(res => {
        if (res.data.code == '0000') {
          const {
            serviceDetailList,
            appealDetails,
            appealNumber
          } = res.data.data
          this.tableData = appealDetails
          this.userList = serviceDetailList
          this.total = appealNumber
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
  section {
    .top-header {
      width: 78.5%;
      display: flex;
      justify-content: space-between;
      font-size: 0.16rem;
      color: rgba(255, 255, 255, 100);

      .header {
        margin-bottom: 0.16rem;
        &::before {
          content: '';
          vertical-align: middle;
          width: 0.03rem;
          height: 0.18rem;
          display: inline-block;
          margin-right: 0.1rem;
          background: #00fffe;
        }
      }
      b {
        color: #00fffe;
        margin: 5px;
      }
    }

    .demandBox {
      margin-top: 0.1rem;
      // display: flex;
      // justify-content: space-between;
      .serviceBox {
        width: 100%;
        /deep/ .el-table {
          background: transparent !important;
          .is-leaf {
            border: none;
          }
          .el-table__header {
            height: 0.48rem;
            box-sizing: border-box;
          }
          thead {
            border: 1px solid rgba(46, 178, 236, 0.5);
            box-sizing: border-box;
            th,
            tr {
              font-size: 0.14rem;
              color: rgba(0, 255, 254, 100);
              background-color: rgba(0, 103, 166, 0.25);
            }
          }
          tbody {
            tr {
              background: transparent !important;
            }
            tr:nth-child(even) {
              background: rgba(0, 103, 166, 0.25) !important;
            }
            tr:hover {
              background-color: rgba(0, 103, 166, 0.25) !important;
              box-shadow: inset 0px 0px 20px 0px rgba(0, 255, 254, 1);
            }
            tr:hover > td {
              background: transparent;
            }
            td {
              color: rgba(255, 255, 255, 0.85);
              font-size: 0.16rem;
              border: none;
            }
          }

          .el-table__body-wrapper {
            min-height: 3.6rem;
          }
        }
      }
      .personnel {
        width: 2.9rem;
        height: 4.4rem;
        overflow: scroll;
        padding: 0.16rem 0.24rem;
        background-color: rgba(0, 103, 166, 0.25);
        border: 1px solid rgba(46, 178, 236, 0.5);
        position: relative;
        margin-left: 0.24rem;
        &-title {
          i {
            display: inline-block;
            width: 0.22rem;
            height: 0.22rem;
            background: url('../../../../assets/images/appeal-user.png')
              no-repeat;
            background-size: 100%;
            vertical-align: bottom;
            margin-right: 0.1rem;
          }
          color: rgba(255, 255, 255, 100);
          font-size: 0.16rem;
        }
        &-list {
          display: flex;
          margin-top: 0.16rem;
          margin-bottom: 0.2rem;
          img {
            width: 0.9rem;
            height: 0.88rem;
            border-radius: 0.08rem;
            margin-right: 0.2rem;
          }
          &-rights {
            color: rgba(255, 255, 255, 100);
            font-size: 0.14rem;
            .name {
              width: 0.8rem;
              height: 0.28rem;
              line-height: 0.28rem;
              text-align: center;
              background: url('../../../../assets/images/appeall.png') no-repeat
                center;
              background-size: 100%;
            }
            .address {
              font-size: 0.12rem;
              line-height: 0.2rem;
              margin-top: 0.04rem;
              span {
                color: rgba(0, 255, 254, 100);
              }
            }
          }
        }
        &-empty {
          position: absolute;
          top: calc(50% - 0.75rem);
          left: calc(50% - 0.56rem);
          width: 1.12rem;
          height: 1.5rem;
          text-align: center;
          color: rgba(199, 241, 255, 100);
          font-size: 0.14rem;
          img {
            width: 1.18rem;
            height: 1.2rem;
            margin-bottom: 0.08rem;
          }
        }
      }
      .personnel::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
// 滚动条样式
/deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #063570;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0.1rem;
  opacity: 0.5;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 0.15rem;
  background-color: #0257aa;
}
</style>
